// @core/api/endpoints/affiliate/create_offer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateOfferRequest,
  OfferResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Create offer
 * Creates a new offer with the provided data. Returns the created resource.
 */
export async function CreateOffer(
  data: CreateOfferRequest,
  options?: RequestOptions
): Promise<OfferResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/offers`;
  const requestOptions = options;
  return client.post<OfferResponse>(requestPath, data, requestOptions);
}
